<template>
	<div class="sector p-2">
		<div class="card-body" :style="style">
			<div class="overlay" v-if="!released"></div>
			<div class="row">
				<div class="col-12">
					<model-viewer disable-zoom v-if="released" class="runestone-model"
												:src="`/content/runestones/${sector.name}.glb`"
												camera-orbit="0deg 75deg 85%"
												camera-controls auto-rotate shadow-intensity="1" style="--poster-color:'transparent'"
												environment-image="neutral"></model-viewer>
				</div>
			</div>
			<div class="row text-center mt-3">
				<div class="col-6">
					<div class="">
						<h1>{{ sector.name }}</h1>
						<h3>{{ sector.release_date ? sector.release_date : 'Coming Soon' }}</h3>
					</div>
				</div>

				<div class="col-6">
					<div class="">
						<h2>{{ sector.location ? sector.location : 'Unknown' }}</h2>
						<!--						<h3>{{ released ? released : 0 }} / {{ sector.tiles_available }}</h3>-->
												<h3>{{ released ? released : 0 }} Released</h3>
						<!--					<h6>{{ sector.rank }}</h6>-->
					</div>
				</div>

				<div class="col-8 offset-2 mt-3">
					<button class="btn btn-secondary mt-2 btn-sm me-3 btn-block" v-if="released" disabled>SOLD OUT</button>
					<!--					<a href="#buy" class="btn btn-secondary mt-2 btn-sm me-3 btn-block" v-if="released">Buy</a>-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import "@google/model-viewer"

export default {
	name: "Sector",
	props: {
		sector: {
			type: Object,
			required: true
		}
	},
	computed: {
		released() {
			return this.sector.tiles_released;
		},
		style() {
			const bgCol = this.hexToRgb(this.sector.color)
			if (bgCol === null)
				return {}

			return {
				// borderColor: "black",
				// borderColor: this.released ? this.sector.color : 'white',
				// backgroundColor: this.released ? `rgba(${bgCol.r}, ${bgCol.g}, ${bgCol.b}, 1)` : '',
			}
		}
	},
	methods: {
		hexToRgb(hex) {
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result ? {
				r: parseInt(result[1], 16),
				g: parseInt(result[2], 16),
				b: parseInt(result[3], 16)
			} : null;
		}
	}
}
</script>

<style scoped>

.card-body {
	/*border: 1px solid;*/
	border-radius: 9px;
	position: relative;
}

h1 {
	font-size: 1.2em;
}

h2 {
	font-size: 1em;
	color: white;
}

h3 {
	font-size: 0.8em;
	color: white;
}

h6 {
	font-size: 2.5em;
}

.sector {
	color: white;
}

.overlay {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	border-radius: 9px;
	background: rgba(128, 128, 128, 0.2);
	z-index: 9;
}


.runestone-model {
	width: 100%;
}

.info {
	padding-top: 15px;
	margin-top: 15px;
	color: grey;
}

.sector .card-body {
	border: 2px solid white;
	border-radius: 9px;
	background: rgba(255, 255, 255, 0.2);
}
</style>